<template>
  <nav class="navbar navbar-expand-xxl border-0">
    <!-- Мобильная версия - горизонтальная -->
    <div class="d-flex d-xl-none flex-row w-100 overflow-auto">
      <a
        class="nav-link rounded py-2 px-3 mt-1 flex-shrink-0"
        :class="{ active: active === nav.id }"
        aria-current="page"
        @click="$emit('changeActive', nav.id)"
        style="cursor: pointer"
        v-for="(nav, i) in navs"
        :key="nav.id + i"
      >
        <i v-if="nav.icon" :class="nav.icon"></i>
      </a>
    </div>

    <!-- Десктоп версия - вертикальная -->
    <div class="d-none d-xl-flex flex-column col-2 col-xl-12">
      <a
        class="nav-link rounded py-2 mt-1"
        :class="{ active: active === nav.id }"
        aria-current="page"
        @click="$emit('changeActive', nav.id)"
        style="cursor: pointer"
        v-for="(nav, i) in navs"
        :key="nav.id + i"
      >
        <i v-if="nav.icon" :class="nav.icon" class="d-none d-xl-inline"></i>
        {{ $getLocale(nav.name) }}
      </a>
    </div>
  </nav>
</template>

<script lang="ts">
import { Options, Vue, prop } from "vue-class-component";
import { configurations } from "@/store/modules/hotel/configuration";
import type { DashboardNav as Nav } from "@/@types/layouts_nav/dashboard";

class Props {
  navs = prop<Nav[]>({ required: true, default: [] });
  active = prop<string>({ required: true, default: "" });
}

@Options({
  components: {},
})
class DashboardStartNavbar extends Vue.with(Props) {
  theme = localStorage.getItem("data-bs-theme");
  scrolled = false;
  private config = configurations();
  private logoFolder = "main/configuration/logo/mobile";

  get logo(): string {
    return this.$getWebImage(this.config.getLogo, this.logoFolder);
  }

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  }

  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    this.scrolled = window.scrollY > 50;
  }
}
export default DashboardStartNavbar;
</script>
<style lang="scss" scoped></style>
